import React, { useState } from 'react';
import PowerBIReports from '../components/shared/PowerBIReports';

const Reports = () => {
  const [activeTab, setActiveTab] = useState('saturation');

  const tabs = [
    { id: 'saturation', label: 'Change Saturation', description: 'Monitor change capacity and overload risks' },
    { id: 'readiness', label: 'Stakeholder Readiness', description: 'Track stakeholder adoption and readiness levels' },
    { id: 'sentiment', label: 'Sentiment Analysis', description: 'Analyze stakeholder sentiment and feedback' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'saturation':
        return <PowerBIReports />;
      
      case 'readiness':
        return (
          <div style={{ padding: '40px', textAlign: 'center', height: 'calc(100vh - 120px)', background: '#f8f9fa' }}>
            <div style={{ maxWidth: '600px', margin: '0 auto' }}>
              <h3 style={{ color: '#666', marginBottom: '20px' }}>📊 Stakeholder Readiness Report</h3>
              <div style={{ background: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <p style={{ color: '#888', fontSize: '16px', lineHeight: '1.6' }}>
                  This report will show stakeholder adoption levels, readiness scores, and change capacity metrics across your organization.
                </p>
                <p style={{ color: '#666', fontSize: '14px', marginTop: '20px' }}>
                  📈 Features coming soon:<br/>
                  • Individual stakeholder readiness scores<br/>
                  • Department-level adoption tracking<br/>
                  • Change capacity utilization<br/>
                  • Readiness trend analysis
                </p>
              </div>
            </div>
          </div>
        );
      
      case 'sentiment':
        return (
          <div style={{ padding: '40px', textAlign: 'center', height: 'calc(100vh - 120px)', background: '#f8f9fa' }}>
            <div style={{ maxWidth: '600px', margin: '0 auto' }}>
              <h3 style={{ color: '#666', marginBottom: '20px' }}>💭 Sentiment Analysis Report</h3>
              <div style={{ background: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                <p style={{ color: '#888', fontSize: '16px', lineHeight: '1.6' }}>
                  This report will analyze stakeholder sentiment, feedback patterns, and emotional responses to change initiatives.
                </p>
                <p style={{ color: '#666', fontSize: '14px', marginTop: '20px' }}>
                  🔍 Features coming soon:<br/>
                  • Sentiment trend analysis<br/>
                  • Feedback categorization<br/>
                  • Emotional response mapping<br/>
                  • Communication effectiveness metrics
                </p>
              </div>
            </div>
          </div>
        );
      
      default:
        return <div>Unknown tab</div>;
    }
  };

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      {/* Header */}
      <div style={{ padding: '15px 20px', background: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
        <h2 style={{ margin: '0 0 10px 0', color: '#333' }}>
          📊 Change Management Reports
        </h2>
        <p style={{ margin: '0', fontSize: '14px', color: '#666' }}>
          Monitor and analyze change initiatives across your organization
        </p>
      </div>

      {/* Tabs */}
      <div style={{ background: 'white', borderBottom: '2px solid #e9ecef' }}>
        <div style={{ display: 'flex', paddingLeft: '20px' }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '12px 24px',
                border: 'none',
                background: activeTab === tab.id ? '#007bff' : 'transparent',
                color: activeTab === tab.id ? 'white' : '#666',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: activeTab === tab.id ? '600' : '400',
                borderRadius: activeTab === tab.id ? '4px 4px 0 0' : '0',
                marginRight: '4px',
                transition: 'all 0.2s',
                borderBottom: activeTab === tab.id ? '2px solid #007bff' : '2px solid transparent'
              }}
              title={tab.description}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ flex: 1, overflow: 'hidden' }}>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Reports;
